import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_IMAGES = "GET_IMAGES";
export const CAI_LOADING = "CAI_LOADING";
export const CAI_LOADING2 = "CAI_LOADING";
export const ADD_IMAGE = "ADD_IMAGE";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  }
});

export const getImages = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAI_LOADING
    });
    await instance.get(`/Images/GetAllImages/${Token}`).then((res => {
      dispatch({
        type: GET_IMAGES,
        data: res.data
      });
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const getImages2 = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAI_LOADING2
    });
    await instance.get(`/Images/GetAllImages/${Token}`).then((res => {
      dispatch({
        type: GET_IMAGES,
        data: res.data
      });
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const addImage = (baner, background, user) => {
  var Token = convertSHA()
  const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
  let formData = new FormData();

  if (baner == '') {
    baner = '-1'
  }
  else {
    formData.append('banner', baner);
  }

  if (background == '') {
    background = '-1'
  }
  else {
    formData.append('backg', background);
  }

  return async dispatch => {
    dispatch({
      type: CAI_LOADING2
    });
    //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
    await instance.put(`Images/PutInsUpdtImage2/1&true&${user}&${Token}`, formData, config).then((res => {
      dispatch({
        type: ADD_IMAGE,
        data: res.data
      });
      console.log(res);
      console.log(res.data);
    })).catch(function (error) {
      console.log("Error", error);
    });
  }
}